import { render, staticRenderFns } from "./PostcodeMargin.vue?vue&type=template&id=871fd6da&scoped=true&"
import script from "./PostcodeMargin.vue?vue&type=script&lang=ts&"
export * from "./PostcodeMargin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fd6da",
  null
  
)

export default component.exports